export const locale = {
  GLOBAL: {
    Title: "Payamak Land",
    PostalCode: "Postal Code",
    postalCodes: "Postal Codes",
    selectedPostalCodes: "Selected Postal Codes",
    MciNumberCount: "MCI Number Count",
    MtuNumberCount: "Irancell Number Count",
    TotalCount: "Total Count",
    Coefficient: "Coefficient",
    Back: "Back",
  },
  ERRORS: {
    PhoneIsNotValid: "The entered phone number is not valid: e.g. 09101234567",
    InvalidNumber: "The entered number is not valid",
    NoSelectedLineNumber: "Please select a sender line.",
    EmptyText: "Please enter the message text.",
    UnknownError: "Unknown error",
    TryAgain: "Please try again later.",
    NoAccountCharge: "Insufficient balance",
    NoAccess: "You do not have access.",
    PleasebyeAPlane: "Please purchase a plan.",
    PleaseChargeYourAccount: "Please top up your account.",
    AccessDenied: "Access denied.",
    AccessDeniedDescription: "For more information, please contact support",
    Error: "Error",
    InvalidText: "Invalid text",
    InvalidTextContainsLink: "Only service lines can contain links.",
  },
  INFOS: {
    SuccessSentSms: "Message sent successfully",
    SmsRequestInQueue: "Your message will be sent after admin approval",
    SendData: "Sending Information",
    CheckData: "Please read and confirm the information below.",
  },
  TOBE: {
    to: "to ",
    from: "from ",
  },
  FORMS: {
    DestinationPhone: "Recipient Phone Number",
    TestDestinationPhone: "Test Phone Number",
    SourceNumber: "Sender Number",
    Text: "Message",
    CharCount: "Character Count",
    FarsiCharCount: "Persian Character Count",
    EnglishCharCount: "English Character Count",
    Send: "Send",
    SendTime: "Send Time",
    SendTest: "Send Test",
    SendToTestNumber: "Send to Test Number",
    SmsCount: "SMS Count",
    SmsLang: "SMS Language",
    Add: "Add",
    FromFile: "Add from File",
    TestNumber: "Test Number",
    Test: "Test",
    ServiceRelated: "Service Line",
    Price: "Price",
    NumbersCount: "Number Count",
    NumbersCountToSend: "Number of recipients",
    Search: "Search",
    Title: "Title",
    RequestTime: "Request Time",
    RequestInformation: "Request Information",
    CreateNewPhoneBook: "Create New Phonebook",
  },
  BUTTONS: {
    OK: "OK",
    AccountCharge: "Top Up Account",
    Reports: "Reports",
    RemoveAll: "Remove All",
    BuyAPlane: "Buy Plan",
    Accept: "Accept",
    Reject: "Reject",
    Yes: "Yes",
    No: "No",
    Create: "Create",
    New: "New",
    Save: "Save",
    Delete: "Delete",
    More: "More",
    TryAgain: "Try Again",
    Close: "Close",
    RollBack: {
      back: "Return to previous user",
      goToMainUser: "Return to main user",
      CurrentUser: "Current User",
    },
  },
  DIALOGS: {
    Waiting: "Please wait",
    RejectItQuestion: "Reject?",
    AcceptItQuestion: "Accept?",
    Rejected: "Rejected",
    Accepted: "Accepted",
    Error: "Error",
  },
  CONFIRM: {
    Delete: "Are you sure you want to delete?",
    DeleteA: "Are you sure you want to delete {a}?",
    DeleteALL: "Are you sure you want to delete all?",
  },
  LANGUAGE: {
    English: "English",
    Persian: "Persian",
  },
  language: {
    selectAll: "Select All",
    lang: {
      fa: "Persian",
      ar: "Arabic",
      ar_ae: "Arabic (UAE)",
      ar_iq: "Arabic (Iraq)",
      en_US: "English (USA)",
      en_GB: "English (UK)",
      de: "German",
      fr: "French",
      zh_CN: "Simplified Chinese",
      zh_TW: "Traditional Chinese",
      tr: "Turkish",
      ru: "Russian",
      hy: "Armenian",
    },
    only_manual_now: "Only manual translation is available right now",
    ai_coming_soon: "AI translation coming soon",
    got_it: "Got it",
    origin_language: "Source Language",
    target_languages: "Target Languages",
    remove_all: "Remove All Languages",
    translation_method: "Select Translation Method",
    manual_translation: "Manual Translation",
    ai_translation: "AI Translation",
    coming_soon: "Coming Soon",
    source_language_updated: "Source language updated",
    error_changing_source_language: "Error updating source language",
    source_language_created: "New source language created",
    languages_saved: "Languages saved",
    error_saving_languages: "Error saving languages",
    error_loading_language: "Error loading language",
    languages_removed: "Languages removed",
    new_languages_to_save: "New languages to save",
    saved: "Saved",
    management_langs: "Language Management",
    add_langs: "Add Language",
    change_language: "Change Language",
    visit_card: "Business Card",
    translate_to: "Translate to",
    main_language: "Language",
    no_languages_available: "No languages available",
    return_to_default: "Back to Default Language",
    translate: "Translate",
    apply_changes: "Applying changes…",
    changes_pending: "changes_pending",
    cancel_changes: "Cancel",
  },

  LISTS: {
    NoData: "No data available",
    NoDataFound: "No data found",
    NoDataFoundFor: "No data found for {a}",
    NoPhoneNumber: "No phone number found",
    NoPostalCode: "No postal code found",
    AddANumber: "Add a number",
    City: "City",
    AddedBefore: "Already added",
  },
  PAGES: {
    SendSms: "Send SMS",
    MapSms: "Map-Based Sending",
    PhoneBook: "Phonebook",
  },
  MONETARY: {
    Rial: "Rial",
  },
  HINTS: {
    SendMessageTitle:
      "The title is an optional name you can choose. You can reuse titles from previously sent messages to auto-fill the message text. The title is not sent in the SMS and is used for reporting and message suggestions.",
    SendMessageTime:
      "Send time is when your message enters the sending queue. Please note that the message will only be sent after admin approval.",
    CreatePhoneBook:
      "This name will be used when adding numbers from the phonebook during SMS sending.",
  },
  TOASTS: {
    SuccessCreate: "Created successfully",
    FailedCreated: "Failed to create",
    SuccessDelete: "Deleted successfully",
    FailedDelete: "Failed to delete",
    SuccessEdit: "Edited successfully",
    FailedEdit: "Failed to edit",
    AddedSuccess: "Added successfully",
    AddedFailed: "Failed to add",
  },
  WALLET: {
    CustomCharge: "Custom Amount",
    GateWay: "Payment Gateway",
    Price: "Amount",
    Details: [
      "9% tax will be added to the entered amount.",
      "Please double-check the amount. Deposits are non-refundable.",
    ],
    noGateWay: "No payment gateway has been set for you.",
    PriceNotInRange: "The amount must be between {min} and {max} Rials.",
    Pay: "Pay",
    ErrorOnRedirectToGateWay: "Error redirecting to payment gateway",
    ChargeWalletButtonDescription: "Click the + button to top up your account",
  },
  login: {
    phoneField: {
      placeholderIran: "Start with 9 (e.g. +98 912 345 6789)",
      placeholderDefault: "Enter your phone number",
      maxDigitsError: "Maximum {count} digits allowed!",
      iranMustStartWith9: "Mobile number must start with 9 (e.g. 912...)",
    },
    signup_button: "Sign me up!",
    forget_password_title: "Forgot Password",
    register_title: "Free Registration",
    login_title: "Login",
    back: "Back",
    username_label: "Mobile Number / Username",
    otp_resend_button: "Resend Code",
    password_label: "Password",
    password_hint: "At least 8 characters",
    name_label: "First Name",
    name_rule: "At least 3 characters",
    lastname_label: "Last Name",
    phone_label: "Mobile Phone",
    nid_label: "National ID",
    parent_phone_label: "Referrer Phone (optional)",
    terms_and_conditions_message:
      "By registering, you agree to the terms and conditions of Advertising Terminal.",
    terms_and_conditions_link: "Terms and Conditions",
    close: "Close",
    forgot_password_link: "Forgot your password?",
    change_password: "Change Password",
    register_button: "Register",
    login_button: "Login",
    login_with_google: "Login with Google",
    login_with_sms: "Login with SMS",
    login_with_password: "Login with Password",
    already_registered: "Already registered?",
    login_here: "Login",
    no_account: "Don't have an account?",
    signup_now: "Sign up now!",
    more_info: "More Information",
    text_login: "Login",
    text_register: "Register",
    required_field: "This field is required.",
    min_8_char: "Your field is shorter than 8 characters",
    required: "This field is required",
    min_3_char: "At least 3 characters",
    max_50_char: "Maximum 50 characters",
    no_internet: "You are not connected to the internet",
    no_phone_entered: "You have not entered a phone number",
    otp_sent_successfully: "Verification code sent successfully.",
    please_register_first: "Please register first!",
    wait_3_min: "Please wait 3 minutes and try again.",
    login_successful: "Logged in successfully",
    internet_connection_error: "Internet connection problem!",
    agree_to_terms_error: "You have not agreed to the terms and conditions!",
    otp_sent_successfully_register: "Verification code sent successfully.",
    error: "Error",
    registration_nid_required_notice:
      "To provide high-security services and prevent fraud (phishing) and misuse of the system, entering the National ID is mandatory for registration in Advertising Terminal.",
  },
  home: {
    title: "Home",
    selectSystem: "Select System",
    yourPoints: "Your Points",
    discountCodes: "Discount Codes",
    all: "All",
    discounts: "Discounts",
    systemGuide: "System Guide",
    yourPointsDynamic: "Your points: {points}",
    confirm: "Confirm",
    copy: "Copy",
  },
  badges: {
    free: "Free",
    preRegister: "Pre-registration",
    comingSoon: "Coming Soon",
    testVersion: "Beta Version",
  },
  services: {
    qrLand: {
      title: "QR Land System",
      description: "Dynamic QR Code Creation",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    payamak: {
      title: "Payamak Land System",
      description: "Bulk Promotional SMS",
      property: {
        0: "Bulk SMS sending",
        1: "Up-to-date number database",
        2: "Sending SMS to customer club",
        3: "Integration with all websites and software",
      },
    },
    robot: {
      title: "Robot Land System",
      description: "Simultaneous management of all numbers, ads and panels",
      property: {
        0: "Bulk and group ad posting",
        1: "Timed, gradual and smart ad management",
        2: "Unlimited number rental and addition for ad posting",
        3: "Simultaneous registration and management of all ads",
      },
    },
    infoLand: {
      title: "Info Land",
      description: "Over 2500 up-to-date business databases",
      property: {
        0: "All business information available",
        1: "Categorized by cities and provinces",
        2: "National business database",
        3: "Ability to view samples of all databases",
      },
    },
    graphic: {
      title: "Graphic Land System",
      description: "Full graphic design and video services",
      property: {
        0: "Logo and stationery design",
        1: "All printing and packaging services",
        2: "Catalog, brochure and box design",
        3: "Design and printing of various banners in different sizes",
      },
    },
    bestWebLand: {
      title: "Best Web Land System",
      description: "Website design, support and SEO",
      property: {
        0: "Content SEO",
        1: "Off-page SEO",
        2: "Technical SEO",
        3: "On-page SEO",
      },
    },
    onlineShop: {
      title: "Online Shop Builder",
      description: "Just a few clicks away from the digital world",
      badge: "Affiliate Sales",
      property: {
        0: "Content SEO",
        1: "Off-page SEO",
        2: "Technical SEO",
        3: "On-page SEO",
      },
    },
    social: {
      title: "Social Media Advertising",
      description: "Review and selection of the best pages and channels",
      property: {
        0: "Review of all high-traffic pages",
        1: "Integrated management of all covered advertisements",
        2: "No need to pay commission or extra fees",
        3: "Online ordering of ads on selected pages",
      },
    },
    billboard: {
      title: "Online Billboard Rental",
      description:
        "Direct and targeted billboard selection without intermediaries",
      property: {
        0: "Review of billboard location and type",
        1: "Management of all covered billboards",
        2: "Direct contact with billboard owners without intermediaries",
        3: "No need to pay commission or extra fees",
      },
    },
    internationalMedia: {
      title: "National Media Advertising",
      description: "Review and placement of ads on TV and radio",
      property: {
        0: "Review and selection of broadcast timing",
        1: "Review and selection of TV advertisement types",
        2: "Review and selection of radio advertisement types",
        3: "Review and selection of program-specific advertising",
      },
    },
    transport: {
      title: "Transport Fleet Advertising",
      description: "Airports, train stations, buses and subway",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of subway advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all placed advertisements in subway",
      },
    },
    cinema: {
      title: "Visual Media Advertising",
      description: "Cinema and video-sharing website advertisements",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    estate: {
      title: "Online Real Estate System",
      description: "File, consultant and client management",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    AIGeneration: {
      title: "Artificial Intelligence System",
      description: "Image generation, chatbot",
    },
    ShortLink: {
      title: "Short Link System",
      description: "Short link creation",
    },
    customer: {
      title: "Online Customer Management System",
      description: "Management, support and creation of loyal customers",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    internetBroadcasting: {
      title: "Internet Advertising Management",
      description: "Google Ads, PPC, sponsored articles",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    emailMarketing: {
      title: "Email Marketing System",
      description: "Promotional email sending to all businesses in the country",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    adsOnStudium: {
      title: "Stadium and Exhibition Advertising",
      description: "Brand presence in major venues",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    bidOnline: {
      title: "Comprehensive Online Auction System",
      description: "Create auctions online, participate in auctions",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    onlineTools: {
      title: "Online Business Tools System",
      description: "All auxiliary tools for any type of business",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    onlineLearn: {
      title: "Online Business Training System",
      description: "Targeted review and selection of training courses",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    cloud: {
      title: "Hosting and Domain Purchase",
      description: "Purchase hosting, domain and server",
      property: {
        0: "Review and selection of advertisement type and location",
        1: "Review and selection of cinema advertisement types",
        2: "No need to pay commission or extra fees",
        3: "Integrated management of all advertisements placed in cinemas",
      },
    },
    QrlandShop: {
  title: "Online Store Management",
  description: "Integrated management of products, marketplaces, and smart pricing",
  property: {
    0: "Comprehensive product monitoring and management",
    1: "Product variant management",
    2: "Marketplace monitoring and management",
    3: "Smart pricing strategies",
  },
},

  },
  "planning.title": "Planning",
  "tabs.reminder": "Reminders",
  "tabs.notes": "Notes",
  "tabs.calendar": "Calendar",
  "notes.creationDate": "Creation Date",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "actions.quickActions": "Quick Actions",
  "notes.writeMessage": "Write a note",
  "notes.titlePlaceholder": "Note Title",
  "notes.addNote": "Add Note",
  "notes.updatedSuccess": "Note updated successfully.",
  "notes.addedSuccess": "Note added successfully.",
  "common.deletedSuccess": "Deleted successfully",
  "common.confirmDelete": "Are you sure you want to delete?",
  "news.title": "Site News",
  "news.noNews": "No news has been published on the site.",
  "news.view": "View",
  "remember.add": "Create Reminder",
  "remember.update": "Update Reminder",
  "remember.titleLabel": "Title",
  "remember.dateLabel": "Reminder Date",
  "remember.confirmDelete": "Are you sure you want to delete?",
  "remember.deleteSuccess": "Reminder deleted successfully.",
  "remember.createSuccess": "New reminder created.",
  "remember.updateSuccess": "Reminder updated.",
  "points.receivedAwards": "Received Rewards",
  "points.pointsHistory": "Points History",
  "points.points": "Points",
  "points.discountTitle": "Robot Land Discount",
  "points.discountText": "For every 500 points",
  events: {
    title: "Events",
    addEvent: "Add Event",
    calendar: "Base Calendar",
    close: "Close",
    save: "Save",
    update: "Update",
    confirmDelete: "Are you sure you want to delete?",
    successAdd: "Added successfully.",
    successDelete: "Event deleted successfully.",
    successUpdate: "Updated successfully.",
    titleLabel: "Title",
    descriptionLabel: "Description",
    colorLabel: "Color",
    removeAfterDrop: "Remove after drop",
    createEvent: "Create Event",
  },
  copySuccess: "Copied successfully.",
  copyTextTitle: "Copy Text",
  copiedTextTitle: "Copied",
  ribbon: {
    new: "New",
  },
  coupons: [
    {
      text: "This coupon is valid for 3 weeks",
      title: "Non-repetitive Text 20%",
    },
    {
      text: "This coupon is valid for 2 weeks",
      title: "Website Design 5%",
    },
    {
      text: "This coupon can only be used once",
      title: "Page Management 10%",
    },
    {
      text: "This coupon is permanently active for you",
      title: "Graphic Design 5%",
    },
    {
      text: "This coupon can only be used once",
      title: "Printing 2%",
    },
  ],
  userLinks: {
    profile: {
      title: "Overview",
      invitation: { title: "Invite Friends" },
      info: { title: "Personal Information" },
      edit: { title: "Complete Profile" },
      changePass: { title: "Change Password" },
    },
  },
  profileLinks: {
    orders: "Orders",
    addresses: "Addresses",
  },
  customPage: {
    overview: "Overview",
    personalInfo: "Personal Information",
    changePassword: "Change Password",
    completeProfile: "Complete Profile",
    email: "Email",
    balance: "Balance",
    phone: "Phone",
    rial: "Rial",
  },
  widget12: {
    inviteFriends: "Invite Friends",
    viewInvitedUsers: "View list of users referred by you",
    yourInviteCode: "Your Invite Code",
    createNewUser: "Create New User",
    copyText: "Copy",
    userCreatedSuccess: "New user created successfully",
    notCreated: "Not created",
  },
  userInfo: {
    userInformation: "User Information",
    profilePicture: "Profile Picture",
    allowedFileTypes: "Allowed file types: png, jpg, jpeg.",
    profilePictureSize: "Profile picture must be square (e.g. 480 × 480).",
    firstName: "First Name",
    lastName: "Last Name",
    username: "Username",
    phone: "Phone Number",
    email: "Email",
    receiveSMS: "Receive SMS",
    smsCostNote:
      "By enabling this option, SMS sending costs will be deducted from your account.",
    saveChanges: "Save Changes",
    profileUpdated: "Your profile has been updated successfully.",
  },
  emailSettings: {
    completeProfile: "Complete Profile",
    completeProfileDesc: "Complete personal or organization information",
    cancel: "Cancel",
    update: "Update",
    save: "Save",
    selectPersonType: "Select person type?",
    realPerson: "Individual",
    legalPerson: "Legal Entity",
    phone: "Mobile Phone",
    landline: "Landline",
    fatherName: "Father's Name",
    nationalCode: "National ID",
    idNumber: "ID Number",
    birthday: "Date of Birth",
    placeOfBirth: "Place of Birth",
    postalCode: "Postal Code",
    email: "Email",
    introduction: "How you found us",
    nationalCodePic: "National ID Card Photo",
    plaque: "Plaque",
    address: "Full Address",
    companyName: "Company/Shop Name",
    registrationNumber: "Registration Number",
    economicCode: "Economic Code",
    organizationIdentity: "National Organization ID",
    companyType: "Company Type",
    activity: "Field of Activity",
    registrationAd: "Company Registration Advertisement Image",
    lastPublishedAd: "Last Official Published Advertisement Image",
    statute: "Company Statute Image",
    agentLetterPic: "Representative Introduction Letter Image",
    successMessage: "Saved successfully",
    errorSelectType: "Please select an option.",
    rules: {
      companyName: "Company/shop name field is required.",
      registrationNumber: "Registration number field is required.",
      economicCode: "Economic code field is required.",
      organizationIdentity: "National organization ID field is required.",
      registrationAd: "Company registration advertisement image is required.",
      lastPublishedAd:
        "Last official published advertisement image is required.",
      telephone: "Landline number field is required.",
      fatherName: "Father's name field is required.",
      nationalCode: "National ID field is required.",
      birthday: "Date of birth field is required.",
      idNumber: "ID number field is required.",
      placeOfBirth: "Place of birth field is required.",
      postalCode: "Postal code field is required.",
      nationalCodePic: "National ID card photo is required.",
      address: "Address field is required.",
      plaque: "Plaque field is required.",
    },
    companyTypes: {
      governmental: "Governmental",
      private: "Private",
      commonStock: "Public Joint Stock",
      specialStock: "Private Joint Stock",
    },
  },
  changePassword: {
    title: "Change Password",
    description: "Change your account password",
    cancel: "Cancel",
    update: "Update",
    passwordInstructions: {
      forgotPassword:
        "If you have never set a password before, you can click 'Forgot Password'.",
      passwordRequirements:
        "Password must be 8 characters including numbers, upper and lower case English letters and symbols.",
      passwordPrivacy: "Please do not share your password with others.",
      keyboardLanguage:
        "Ensure your keyboard is set to English when creating a password.",
    },
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm New Password",
    addOrForgotPassword: "Add or Forgot Password",
    changePasswordWithCode: "Change Password with Code",
    close: "Close",
    change: "Change",
    enterCode: "Enter Code",
    successMessage: "Password updated successfully",
    invalidCode: "The code is incorrect.",
    tooManyAttempts: "Too many attempts!",
    rules: {
      required: "This field is required.",
      min: "Your field is shorter than 8 characters",
      equal: "Password and confirmation do not match",
      number: "Enter the number of digits",
    },
  },
  router: {
    dashboard: "Dashboard",
    contacts: "Customer Club",
    editContact: "Edit Customer",
    createContact: "Create Customer",
    customers: "Customer List",
    contactList: "Contact Assistant",
    messages: "Messages",
    messageCategories: "Message Categories",
    oldTransactions: "Old Transactions",
    yourTransactions: "Your Transactions",
    buyPanel: "Buy Panel",
    permissions: "Permissions",
    createPermission: "Create Permission",
    invitations: "My Invitations",
    editUser: "Edit User",
    userInformation: "View User Information",
    walletEdit: "Edit User Wallet Information",
    userHistory: "User History",
    userNotificationsHistory: "User Notifications History",
    notifications: "Notifications",
    createNotification: "Create Notification",
    editNotification: "Edit Notification",
    adminNotifications: "Admin Notifications",
    yourNotifications: "Your Notifications",
    adminNotificationsList: "Admin Notifications",
    tickets: "Tickets",
    createTicket: "Create New Ticket",
    editTicket: "Edit Ticket",
    departments: "Departments",
    createDepartment: "New Department",
    editDepartment: "Edit Department",
    adminTickets: "Ticket Management",
    discounts: "Discounts",
    createDiscount: "Create Discount",
    editDiscount: "Edit Discount",
    workReports: "Work Reports",
    createWorkReport: "Create Work Report",
    callMonitoring: "Call Monitoring",
    adminWorkReports: "Work Report Management",
    editWorkReport: "View and Edit Work Report",
    packProperties: "Package Features",
    createPackProperty: "Create Package Feature",
    editPackProperty: "Edit Package Feature",
    panels: "Panels",
    createPanel: "Create Panel",
    editPanel: "Edit Panel",
    transferRequests: "Withdrawal Requests",
    editTransferRequest: "Edit Withdrawal Request",
    tariffs: "Tariffs",
    createTariff: "Create Tariff",
    editTariff: "Edit Tariff",
    requests: "Requests",
    viewUser: "View User",
    manageTransactions: "Manage Transactions",
    viewTransaction: "View Transaction",
    manageConfigs: "Manage Settings",
    rbLandConfigs: "Robot Land Settings Management",
    editConfig: "Edit Settings",
    manageUsers: "Manage Users",
    categories: "Categories",
    createCategory: "Add Category",
    editCategory: "Edit Category",
    content: "Content",
    createContent: "Add Content",
    editContent: "Edit Content",
    addUserGuide: "Add User Guide",
    editUserGuide: "Edit User Guide",
    roles: "Roles",
    editRole: "Edit Role",
    createRole: "Add Role",
    permissionTitle: "Permissions",
    paymentGateways: "Payment Gateways",
    editPaymentGateway: "Edit Payment Gateways",
    campaigns: "Campaigns",
    createCampaign: "Create Campaign",
    editCampaign: "Edit Campaign Information",
    adminCustomers: "Customers",
    createCustomer: "Create Customer",
    editCustomerInfo: "Edit Customer Information",
    referrerCustomers: "Referrer Customers",
    customerHistory: "Customer History",
    userProfile: "User Profile",
    editProfile: "Edit Profile",
    inviteFriends: "Invite Friends",
    personalInfo: "Personal Information",
    editPersonalInfo: "Edit Personal Information",
    changePassword: "Change Password",
    newWallet: "New Wallet",
  },
  profileView: {
    email: "Email",
    balance: "Balance",
    personType: "Person Type",
    currency: "Rial",
    unknown: "----",
  },
  panelInfoProfile: {
    panelTitle: "You have the {title} panel which is valid for {days} days.",
    buyOrRenew: "To purchase or renew your panel, click the button below.",
    buyPanel: "Buy Panel",
    percentage: "%",
  },
  profileSetting: {
    cardTitle: "Profile Settings",
    changePasswordTitle: "Change Login Password",
    changePasswordSubtitle: "Change your account login password.",
    alertMessage:
      "If you have never entered a password before, please enable the 'Set Password' option.",
    currentPasswordLabel: "Current Password",
    setPasswordLabel: "Set Password",
    addPassword: "Add Password",
    newPasswordLabel: "New Password",
    repeatPasswordLabel: "Repeat Password",
    saveChanges: "Save Changes",
    currentPasswordPlaceholder: "Current Password",
    newPasswordPlaceholder: "New Password",
    repeatPasswordPlaceholder: "Repeat Password",
  },
  profileOrders: {
    cardTitle: "Orders",
    openOrders: "Open Orders ({count})",
    closedOrders: "Closed Orders ({count})",
    noOrders: "You haven't placed any orders yet",
  },
  personalInformation: {
    cardTitle: "Personal Account Information",
    cardSubtitle: "Update your personal information.",
    cancel: "Cancel",
    update: "Update",
    yourInfo: "Your Information",
    profilePicture: "Profile Picture",
    allowedFileTypes: "Allowed file types: png, jpg, jpeg.",
    pictureSize: "Profile picture must be square (e.g. 480 × 480).",
    name: "First Name",
    lastName: "Last Name",
    username: "Username",
    receiveSMS: "Receive SMS",
    smsCostNote:
      "By enabling this option, SMS sending costs will be deducted from your account.",
    phoneNumber: "Mobile Number",
    phonePlaceholder: "Mobile Number",
    email: "Email",
    emailPlaceholder: "Email",
    emailPrivacy: "We will never share your email with anyone else.",
    successMessage: "Your profile has been updated successfully.",
  },
  userInfoForm: {
    companyName: "Company/Shop Name",
    registrationNumber: "Registration Number",
    economicCode: "Economic Code",
    organizationIdentity: "National Organization ID",
    companyType: "Company Type",
    activity: "Field of Activity",
    registrationAd: "Company Registration Advertisement Image",
    lastPublishedAd: "Last Official Published Advertisement Image",
    statute: "Company Statute Image",
    argentLetterPic: "Representative Introduction Letter Image",
    phone: "Mobile Phone",
    telephone: "Landline",
    fatherName: "Father's Name",
    nationalCode: "National ID",
    id: "ID Number",
    birthday: "Date of Birth",
    placeBirthday: "Place of Birth",
    postalCode: "Postal Code",
    email: "Email",
    introduction: "How you found us",
    nationalCodePic: "National ID Card Photo",
    plaque: "Plaque",
    address: "Full Address",
    companyTypes: {
      governmental: "Governmental",
      private: "Private",
      common_stock: "Public Joint Stock",
      special_stock: "Private Joint Stock",
    },
    rules: {
      companyName: "Company/shop name field is required.",
      registration_number: "Registration number field is required.",
      economic_code: "Economic code field is required.",
      organization_identity: "National organization ID field is required.",
      registration_ad: "Company registration advertisement image is required.",
      last_published_ad:
        "Last official published advertisement image is required.",
      telephone: "Landline number field is required.",
      fatherName: "Father's name field is required.",
      nationalCode: "National ID field is required.",
      id: "ID number field is required.",
      birthday: "Date of birth field is required.",
      placeBirthday: "Place of birth field is required.",
      postalCode: "Postal code field is required.",
      nationalCodePic: "National ID card photo is required.",
      address: "Address field is required.",
      plaque: "Plaque field is required.",
    },
  },
  createUserForm: {
    name: "First Name",
    lastName: "Last Name",
    nid: "National ID",
    phone: "Mobile Phone",
    create: "Create",
    errors: {
      nameRequired: "First name is required!",
      lastNameRequired: "Last name is required!",
      nidRequired: "National ID is required!",
      phoneRequired: "Mobile phone is required!",
    },
  },
  lastView: {
    cardTitle: "Your Recent Visits",
    cardSubtitle: "Your recent page visits",
    tableHeaders: {
      page: "Page",
      address: "Address",
      enterDate: "Entry Date",
      leaveDate: "Exit Date",
      timeSpent: "Time Spent",
    },
    viewAll: "View All",
    timeUnit: "minutes",
    pages: {
      home: "Home",
      panels: "Panels",
      profile: "Complete Profile",
    },
  },
walletWidget: {
  title: "Recent Transactions",
  balanceLabel: "Your Balance:",
  viewTransactions: "View Transactions",
  transactionTypes: {
    withdraw: "Withdraw",
    deposit: "Deposit",
    charge: "Wallet Top-up",
    refund: "Refund",
    default: "Transaction",
    adminCharge: "Admin Adjustment", // یا Transaction by Admin
    agency: "Agency Commission",
  },
},
  panelWidget: {
    title: "You have the {title} panel valid for {days} days.",
    renewPrompt: "To purchase or renew your panel, click the button below.",
    buyPanel: "Buy Panel",
    percentage: "{value}%",
    infinity: "∞",
    days: "{count} days",
  },
  component: {
    title: "Users invited by you",
    columns: {
      row: "Row",
      name: "First Name",
      family: "Last Name",
      username: "Username",
      phone: "Mobile Number",
      created_at: "Join Date",
      actions: "Actions",
    },
    unknown: "Unknown",
    error: "Error",
    breadcrumb: "Invited Users",
  },
  table: {
    itemsPerPage: "Rows per page",
    pageText: "Showing {0} to {1} of {2} entries",
    prevText: "Previous",
    nextText: "Next",
    noDataText: "No data available",
    search: "Search",
  },
  UserHistory: {
    title: "User History",
    add_history: "Add New History",
    send_message: "Send Message",
    close: "Close",
    save: "Save",
    cancel: "Cancel",
    new_history_dialog_title: "Add New History",
    send_message_dialog_title: "Send Message",
    negotiations: "Negotiations Conducted",
    follow_up: "Follow-up Items for Next Call",
    success_history: "History recorded successfully.",
    success_message: "Message sent successfully.",
    columns: {
      id: "ID",
      title: "Title",
      status: "Stage",
      current_time_date: "Last Contact Date",
      current_time_hour: "Last Contact Time",
      next_time_date: "Next Contact Date",
      next_time_hour: "Next Contact Time",
      user_id: "Support Agent",
      actions: "Actions",
    },
    table: {
      itemsPerPage: "Rows per page",
      pageText: "Showing {0} to {1} of {2} entries",
      prevText: "Previous",
      nextText: "Next",
      noDataText: "No data available",
      search: "Search",
    },
    form: {
      title: "Title",
      status: "Stage",
      current_time: "Last Contact Date",
      description: "Description",
      next_time: "Next Contact Date",
      pursue_text: "Next Call Follow-up",
      category: "Select Category",
      message_title: "Message Title",
    },
  },
  newUserTransactions: {
    userWallet: "User Wallet",
    transactionList: "Transaction List",
    userTransactions: "User Transactions",
    terminal: "Terminal",
    liveSms: "Live SMS",
    realEstateNews: "Divar Latest",
    rial: "Rial",
    row: "Row",
    uniqueId: "ID",
    amount: "Amount",
    time: "Time",
    createdAt: "Date",
    description: "Additional Description",
    type: "Transaction Type",
    product_description: "Description",
    serviceId: "Service Name",
    balanceAfter: "Balance After",
    perPage: "Count",
    search: "Search",
    balance: "Balance",
    transactionListTooltip: "Transaction List",
    panelLogin: "Panel Login",
    history: "History",
    error: {
      terminalWallet: "Error loading terminal wallet",
    },
    transactionType: "Transaction Type",
    service: "Service",
    dateFrom: "From Date",
    dateTo: "To Date",
    oldWallet: "Old Wallet",
    depositReceipt: "Deposit Receipt",
    showReceipt: "Show Receipt",
    transactionTypes: {
      online: "Online",
      admin: "By Admin",
      refund: "Corrective",
      agency: "Agency",
      withdraw: "Withdrawal",
      deposit: "Deposit",
      adminCharge: "Admin Transaction",
      charge: "Wallet Top-up",
      refund: "Refund",
    },
    error: {
      imageLoad: "Error loading image!",
    },
  },
  buyPanel: {
    alert: {
      choosePanel: "Please carefully select your panel type!",
    },
    dialog: {
      title: "Buy Panel",
      confirmPurchase: "Are you sure you want to purchase the {title} panel?",
      discountCodeLabel: "Discount Code",
      discountCodePlaceholder: "Enter your discount code",
      applyDiscount: "Apply Code",
      purchase: "Purchase",
      iHaveDiscount: "I have a discount code",
    },
    toast: {
      discountApplied: "Your discount code has been applied successfully!",
      purchaseSuccess: "Package purchased successfully",
      error: "An error occurred: {message}",
      unauthorized: "Please log in first",
      validationError: "Validation error: {message}",
    },
    currency: "Rial",
  },
  panelCard: {
    rial: "Rial",
    days: "days",
    buyPanel: "Buy Panel",
  },
  cons: {
    title: "Select Emoji",
  },
  cons1: {
    title: "Default Text",
  },
  MENUS: {
    AD_TERMINAL_SYSTEM: "Advertising Terminal Mega System",
  },
};
